window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};
theme.recentlyViewedIds = [];

(function(){
  // Prevent right-click / drag-save on all images on product pages
  // (main gallery, recommendations, and collection product images on the page)
  if (document.body.classList.contains('template-product')) {
    var isProductPageImage = function (target) {
      if (!target || target.nodeType !== 1) return false;
      return Boolean(target.closest('img, picture, video, .media, .product__media, .card__media, .grid-product__image-mask, .collection-image'));
    };

    document.addEventListener('contextmenu', function (event) {
      if (isProductPageImage(event.target)) {
        event.preventDefault();
      }
    });

    document.addEventListener('dragstart', function (event) {
      if (isProductPageImage(event.target)) {
        event.preventDefault();
      }
    });
  }

  let phsp;
  if ( document.body.classList.contains('template-product') ) {
    // new theme.Sections();
    new theme.AjaxProduct();
    var container = document.querySelectorAll('.product__media-list')[0];
    var sectionId = container.closest('section').getAttribute('id');
    phsp = new theme.Photoswipe(container, sectionId);
  }
  
  if ( document.getElementById('product-grid') ) {
    // new theme.QuickAdd(document.getElementById('product-grid'));
    // console.log(123123123123213123);
  }

  let sliders = document.querySelectorAll('body');
  if ( sliders ) {
    sliders.forEach((item) => {
      new theme.QuickAdd(item);
      // console.log(876876876876876);
    });
  }
  
   function loadRecentlyProducts(theme) {
      // console.log('jsfile');
      var recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds && typeof(recentIds) !== undefined) {
        theme.recentlyViewedIds = JSON.parse(recentIds);
      }

      // Stop if no data
      let container = document.querySelector('[data-section-type="recently-viewed"]');
      if (container && !theme.recentlyViewedIds.length) {
        container.classList.add('hide');
        return;
      }

      this.outputContainer = document.getElementById('RecentlyViewed');

      if ( !this.outputContainer ) return false;
      // var currentId = this.container.getAttribute('data-product-id');

      var url = '/search?view=recently-viewed&type=product&q=';

      var products = '';
      var i = 0;
     let maxProducts = 6;
      theme.recentlyViewedIds.forEach(function(val) {
        // Skip current product
        // if (val === currentId) {
        //   return;
        // }

        // Stop at max
        if (i >= maxProducts) {
          return;
        }

        products += 'id:' + val + ' OR ';
        i++;
      });

      url = url + encodeURIComponent(products);
     
      fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var count = doc.querySelectorAll('.product-grid').length;
        // let containerOut = document.getElementById('RecentlyViewed');
        if (count > 0) {
          var results = doc.querySelector('.product-grid');
          this.outputContainer.append(results);
          new theme.QuickAdd(this.outputContainer);
          container.classList.remove('hide');
        } else {
          this.outputContainer.classList.add('hide');
        }

    });
  }
  loadRecentlyProducts(theme);

  function setRecentlyProducts(theme) {
    var productCurrent = document.querySelector('[name="product-id"]');
    theme.recentlyViewedIds.forEach(function(val) {
      if (val === null ) {
        theme.recentlyViewedIds = [];
      }
    });
    if ( !productCurrent ) return false;
    let id = productCurrent.value;

    if (!id) return;

    // Remove current product if already in recently viewed array
    var i = theme.recentlyViewedIds.indexOf(id);
    if (i > -1) {
      theme.recentlyViewedIds.splice(i, 1);
    } 
    
    theme.recentlyViewedIds.unshift(id);
    if ( theme.recentlyViewedIds.length > 6 ) {
      theme.recentlyViewedIds.length = 6;
    }
    
    // theme.recentlyViewedIds = theme.recentlyViewedIds.slice(1,6);

    if (theme.config.hasLocalStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(theme.recentlyViewedIds));
    }
  }
  setRecentlyProducts(theme);

  
})();

(function($) {
      
  $(document).ready(function() {

    // --- iOS Safari-only manual scroll restoration for collection pages (rebuilt) ---
    // Goal: when navigating back, anchor to the last-clicked product card.
    const isIOSSafari = (() => {
      const ua = navigator.userAgent || '';
      const isIOS = /iPad|iPhone|iPod/.test(ua);
      const isMacSafari = /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome/.test(ua) && !/Chromium/.test(ua);
      const isWebKit = /WebKit/.test(ua);
      const isCriOS = /CriOS/.test(ua);
      const isFxiOS = /FxiOS/.test(ua);
      return (isIOS || isMacSafari) && isWebKit && !isCriOS && !isFxiOS;
    })();

    const isCollectionPage = () => document.body && document.body.classList.contains('template-collection');
    const ZR_SAFARI_KEY = 'zr:safari-collection-anchor:v1';

    const collectionPath = () => {
      try {
        return `${window.location.origin}${window.location.pathname}`;
      } catch (e) {
        return window.location.pathname || '';
      }
    };

    const safeSessionGet = () => {
      try {
        return JSON.parse(window.sessionStorage.getItem(ZR_SAFARI_KEY) || 'null');
      } catch (e) {
        return null;
      }
    };

    const safeSessionSet = (payload) => {
      try {
        window.sessionStorage.setItem(ZR_SAFARI_KEY, JSON.stringify(payload));
      } catch (e) {}
    };

    const safeSessionClear = () => {
      try {
        window.sessionStorage.removeItem(ZR_SAFARI_KEY);
      } catch (e) {}
    };

    const findProductLiFromEventTarget = (targetEl) => {
      if (!targetEl || !targetEl.closest) return null;
      return targetEl.closest('#product-grid li.grid__item[data-product-id]');
    };

    const resolveProductLinkFromCard = (targetEl) => {
      if (!targetEl || !targetEl.closest) return null;
      let link = targetEl.closest('#product-grid a[href]');
      if (link) return link;
      const cardRoot = targetEl.closest(
        '#product-grid li.grid__item, #product-grid .card-wrapper, #product-grid .card, #product-grid .card__content, #product-grid .card__inner'
      );
      if (!cardRoot) return null;
      return cardRoot.querySelector('a.full-unstyled-link[href], a[href*="/products/"]');
    };

    const isNavigationClick = (event, link, targetEl) => {
      if (!event || !link) return false;
      if (event.defaultPrevented) return false;
      if (event.button && event.button !== 0) return false;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;

      // Ignore quick-add/buttons/etc unless user actually tapped the <a>.
      if (!targetEl.closest('a[href]') && targetEl.closest('button, [role="button"], input, select, textarea, label')) {
        return false;
      }

      if (link.hasAttribute('download')) return false;
      const t = link.getAttribute('target');
      if (t && t !== '_self') return false;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return false;
      const abs = link.href || href;
      return typeof abs === 'string' && abs.indexOf('/products/') !== -1;
    };

    const anchorToProductId = (productId) => {
      if (!productId) return false;
      const li = document.querySelector(`#product-grid li.grid__item[data-product-id="${productId}"]`);
      if (!li) return false;
      // Use getBoundingClientRect + pageYOffset for exact Safari-compatible positioning.
      // scrollIntoView is unreliable on iOS Safari after pageshow; window.scrollTo is not.
      const scrollToLi = () => {
        const rect = li.getBoundingClientRect();
        const absoluteTop = rect.top + window.pageYOffset;
        const offset = Math.max(0, absoluteTop - (window.innerHeight / 2) + (rect.height / 2));
        window.scrollTo(0, offset);
      };
      scrollToLi();
      return true;
    };

    const driveInfiniteUntilFound = (productId, maxDurationMs = 12000) => {
      const start = Date.now();
      const stepDelayMs = 250;
      const maxSteps = 80;
      let steps = 0;
      let observer = null;

      const hasNext = () => !!document.querySelector('#pagination-wrapper .infinite_next a, .infinite_next a');
      const kickAjaxinate = () => {
        try {
          document.dispatchEvent(new Event('scroll'));
          window.dispatchEvent(new Event('scroll'));
        } catch (e) {}
      };

      const stop = () => {
        if (observer) observer.disconnect();
        observer = null;
      };

      const tick = () => {
        steps += 1;
        if (anchorToProductId(productId)) {
          stop();
          safeSessionClear();
          return;
        }

        if (!hasNext() || Date.now() - start > maxDurationMs || steps >= maxSteps) {
          stop();
          safeSessionClear();
          return;
        }

        // Scroll near bottom to trigger Ajaxinate's pagination-in-view detection.
        const doc = document.documentElement;
        const maxScrollY = Math.max(0, (doc ? doc.scrollHeight : 0) - window.innerHeight);
        window.scrollTo(0, maxScrollY);
        kickAjaxinate();
        setTimeout(tick, stepDelayMs);
      };

      const grid = document.querySelector('#product-grid');
      if (grid && window.MutationObserver) {
        observer = new MutationObserver(() => {
          // When products append, try anchoring immediately.
          if (anchorToProductId(productId)) {
            stop();
            safeSessionClear();
          }
        });
        observer.observe(grid, { childList: true, subtree: true });
      }

      setTimeout(tick, 0);
    };

    if (isIOSSafari) {
      // Keep native restoration from fighting us (Safari tends to reset to top anyway, but be explicit).
      if ('scrollRestoration' in history) {
        try {
          history.scrollRestoration = 'manual';
        } catch (e) {}
      }

      // ── 1. Save BOTH productId AND scrollY on every product-card click ──────
      const saveScrollState = (event) => {
        if (!isCollectionPage()) return;
        const targetEl = event.target;
        if (!targetEl || !targetEl.closest) return;

        const link = resolveProductLinkFromCard(targetEl);
        if (!link) return;
        if (!isNavigationClick(event, link, targetEl)) return;

        const li = findProductLiFromEventTarget(targetEl) ||
                   targetEl.closest('li[data-product-id]');
        const productId = li && li.getAttribute('data-product-id');
        if (!productId) return;

        safeSessionSet({
          path: collectionPath(),   // pathname only – no query params
          productId,
          scrollY: window.scrollY,  // coarse fallback position
          ts: Date.now(),
        });
      };

      // Listen on both click and touchend — Safari sometimes navigates via touchend
      // before a click event fires, causing the click listener to miss it.
      document.addEventListener('click',    saveScrollState, { capture: true });
      document.addEventListener('touchend', saveScrollState, { capture: true });

      // ── 2–3. Restore on pageshow with immediate coarse scroll + rAF+timeout ─
      window.addEventListener('pageshow', () => {
        if (!isCollectionPage()) return;
        const data = safeSessionGet();

        // URL matching ignores query params (?view=, ?page=, etc.)
        if (!data || data.path !== collectionPath() || !data.productId) return;

        // Step A – immediately jump to the saved Y so the page doesn't flash at top.
        if (typeof data.scrollY === 'number') {
          window.scrollTo(0, data.scrollY);
        }

        // Step B – 100 ms later (layout settles) + rAF: try to anchor to the exact card.
        setTimeout(() => {
          window.requestAnimationFrame(() => {
            if (anchorToProductId(data.productId)) {
              safeSessionClear();
              return;
            }
            // Product not in DOM yet (infinite-scroll page not fully loaded) – drive loader.
            driveInfiniteUntilFound(data.productId);
          });
        }, 100);
      });
    } else {
      // --- Legacy behavior (unchanged) for Chrome/Android/desktop and non-Safari iOS browsers ---
      var isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);
      var eventName = isOnIOS ? "pagehide" : "beforeunload";
      window.addEventListener(eventName, (event) => {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        var centerX = windowWidth / 2;
        var centerY = windowHeight / 2;
        
        var elementsInCenter = document.elementsFromPoint(centerX + 100, centerY);
        let centeredProductId = $(elementsInCenter[0])
                                .closest('li.grid__item').attr('data-product-id');
        
        if ( $('#pagination-wrapper .infinite_next a').length > 0 ) {
          var link = $('#pagination-wrapper .infinite_next a').attr('href');
          var url = new URL(link, 'https://zurmarket.co.il/');
          var page = url.searchParams.get("page");
          var url = new URL(location.href);
          url.searchParams.set("IdToScroll", centeredProductId);
          url.searchParams.set("page", page - 1);
          var newURL = url;
          history.replaceState({}, '', newURL);
        }
      });
      
      var url = new URL(location.href);
      var IdToScroll = url.searchParams.get("IdToScroll");
      if ( IdToScroll ) { 
        let toScroll = $(`li.grid__item[data-product-id="${IdToScroll}"]`);
        if ( ! toScroll ) return false;
        if ( toScroll ) {
          var windowHeight = $(window).height();
          var elementHeight = toScroll.outerHeight();
          if ( ! toScroll.offset() ) return false;
          var scrollPosition = toScroll.offset().top - (windowHeight / 2) + (elementHeight / 2);
          $('html, body').animate({
              scrollTop: scrollPosition
          }, 500);
        }
        
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete("IdToScroll");
        const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
        history.replaceState(null, "", newUrl);
      }
    }

    
    // function hasGetParameter(param) {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     return urlParams.has(param);
    // }
    
    // function performActionIfParamAbsent() {
    //     if (!hasGetParameter('sort_by') && $('body').hasClass('template-collection') ) {
    //       const currentUrl = new URL(window.location.href);
    //       currentUrl.searchParams.set('sort_by', 'best-selling');
    //       window.location.href = currentUrl.toString();
    //     }
    // }
    
    // performActionIfParamAbsent(); 

    $('body').on('click', '.continue_shop', function(e) {
      e.preventDefault();
      $('.js-close-header-cart').trigger('click');
    });
    
    $('.faq_block_container .faq_title').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
    });
    
    /**
     * change looks for product collection page
    */
    $('body').on('click', 'button[data-view]', function(e) {
      e.preventDefault();
      $('button[data-view]').removeClass('is-active');
      $(this).addClass('is-active');
      let view = $(this).attr('data-view');
      $('#product-grid').attr('data-view', view);
    })
   
    // function setSlideHeight(that){
      // $('.gallery-thumbs').css({height:'auto'});
      // var currentSlide = that.activeIndex;
      // var newHeight = $(that.slides[currentSlide]).height();
      // if ( $('.gallery-thumbs .swiper-slide').length < 5 ) {
      //   $('.gallery-thumbs .swiper-wrapper').addClass('centered_slider');
      // }
      // $('.gallery-thumbs .swiper-slide').css({ height : '85px' })
      // that.update();
    // }

    var galleryThumbs, galleryMain; 
    /*
    * slider swiper for single product page
    */
    if ( $(window).width() > 750 ) {
      let slides = $('.gallery-main .product__media-item');
      if ( $('.gallery-main .product__media-item').length > 1 ) {
        galleryThumbs = new Swiper(".gallery-thumbs", {
          // centeredSlides: false,
          // centeredSlidesBounds: false,
          slidesPerView: 5,
          // slidesPerView: 'auto',
          // watchOverflow: false,
          // watchSlidesVisibility: true,
          // watchSlidesProgress: true,
          direction: 'vertical',
          autoHeight: true,
          // initialSlide: 0,
          // autoScrollOffset: 1,
          spaceBetween: 15,
          // slideToClickedSlide: true,
          // loop: true,
          // mousewheel: {
          //   releaseOnEdges: true,
          // },
          // on:{
          //   init: function(){
          //     setSlideHeight(this);
          //   },
          //   slideChangeTransitionEnd:function(){
          //     setSlideHeight(this);
          //   }
          // }
        });
        galleryMain = new Swiper(".gallery-main", {
          // watchOverflow: true,
          // watchSlidesVisibility: true,
          // watchSlidesProgress: true,
          // preventInteractionOnTransition: true,
          // slideToClickedSlide: true,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // effect: 'coverflow',
          thumbs: {
            swiper: galleryThumbs
          }
        });
        galleryMain.on('slideChangeTransitionStart', function() {
          galleryThumbs.slideTo(galleryMain.activeIndex);
        });
        
        galleryThumbs.on('transitionStart', function(){
          galleryMain.slideTo(galleryThumbs.activeIndex);
        });
      } else {
         $('.gallery-thumbs .swiper-wrapper').removeClass('swiper-wrapper');
        $('.gallery-thumbs .swiper-button-prev').remove();
        $('.gallery-thumbs .swiper-button-next').remove();
        $('.gallery-thumbs .swiper-pagination').remove();
        $('.gallery-thumbs .swiper-container').removeClass('swiper-container');
      }
      
      
      
    } else {
      if ( $('.gallery-main .product__media-item').length > 1 ) {
        galleryMain = new Swiper(".gallery-main", {
          // loop: true,
          loopedSlides: 3, 
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
          centeredSlidesBounds: true,
          slideToClickedSlide: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: galleryThumbs
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          }
        });
      } else {
        $('.gallery-main .swiper-wrapper').removeClass('swiper-wrapper');
        $('.gallery-main.swiper-container').removeClass('swiper-container');
        $('.gallery-main .swiper-button-prev').remove();
        $('.gallery-main .swiper-button-next').remove();
        $('.gallery-main .swiper-pagination').remove();
      }
    }

    // galleryMain.on('slideChange', function () {
    //   // Получаем индекс активного слайда
    //   var activeIndex = galleryMain.activeIndex;
    //   if ( galleryMain.activeIndex < 5 ) {
    //     // galleryThumbs.slideTo(activeIndex + 2);
    //   }
      
    // });

    const colorOptionSelector = '[name="Color"], [name="color"], [name="COLOR"], [name="colour"], [name="Colour"], [name="COLOUR"], [name="צבע"]';
    const colorOptionCheckedSelector =
      '[name="Color"]:checked, [name="color"]:checked, [name="COLOR"]:checked, [name="colour"]:checked, [name="Colour"]:checked, [name="COLOUR"]:checked, [name="צבע"]:checked';

    function updateCurrentColorLabel($context) {
      const $picker = $context && $context.length
        ? $context.closest('variant-radios')
        : $('variant-radios');
      const currentVariant = $picker.find(colorOptionCheckedSelector).first().val();
      if (currentVariant) {
        $picker.find('.product-form__input .current_color').text(currentVariant);
      }
    }

    if ($('.template-product').length) {
      updateCurrentColorLabel();
    }

    /**
    * code for change slides in product slide for each variant
    */
    let productCur = null;
    const tbProductJsonEl = document.getElementById('tb-product-json');
    if (tbProductJsonEl && tbProductJsonEl.textContent) {
      try {
        const tbProductData = JSON.parse(tbProductJsonEl.textContent);
        productCur = tbProductData && tbProductData.variants ? tbProductData.variants : null;
      } catch (e) {
        productCur = null;
      }
    }
    
    function variantImage(val) {
      var selectedVariantId = val;
      if (!productCur || !Array.isArray(productCur)) return;
      const variant = productCur.filter(v => v.title === selectedVariantId);
      if (!variant || !variant[0] || !variant[0].featured_media || !variant[0].featured_media.id) return;
      
      if ( $('[date-for-slick]').length > 1 && $('[date-for-slick="' + variant[0].featured_media.id + '"]').length > 0 ) {
        activeMedia = document.querySelector(`[date-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
        var numbers = activeMedia.split("/");
        var firstNumber = parseInt(numbers[0]);
        galleryMain.slideTo(firstNumber - 1);
        galleryMain.slideTo(firstNumber - 1);
      }
    } 

    $('body').on('change', '[name="גודל"]', function() {
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
    });
    
    $('body').on('change', colorOptionSelector, function() {
      updateCurrentColorLabel($(this));
      variantImage($(this).val());
    });

    let variatn = $(colorOptionCheckedSelector).first();
    if (variatn.length > 0) {
      variantImage(variatn.val());
    }
    
    /**
    * code for toggle sorting in mobile filter
    */
    $('body').on('click', '.mobile-facets__sort .label_box', function(e) {
      if ( $(window).width() > 750 ) return false;
      e.preventDefault();
      $(this).closest('.mobile-facets__sort').toggleClass('active');
    });

    $('body').on('click', '#FacetFiltersFormMobile', function(e) {
      if (e.target !== this) return;
      const summary = document.querySelector('menu-drawer.mobile-facets__wrapper summary.mobile-facets__open-wrapper');
      if (summary) summary.click();
    });

    function setMobileCollectionFilterPosition() {
      if (window.innerWidth >= 750 || !$('.facets-vertical .facets-wrapper').length) {
        return;
      }

      const scrolledHeader = typeof getMobileCollectionFiltersStickyTop === 'function'
        ? getMobileCollectionFiltersStickyTop()
        : ($('#SiteHeader').innerHeight() || 110);

      document.documentElement.style.setProperty('--collection-filters-sticky-top', scrolledHeader + 'px');
      document.querySelector('.facets-vertical .facets-wrapper').style.top = scrolledHeader + 'px';
    }

    setMobileCollectionFilterPosition();
    $(window).on('resize', setMobileCollectionFilterPosition);
    document.addEventListener('headerStickyChange', setMobileCollectionFilterPosition);

    function checkLenghtDesc() {
      const desc = document.getElementById('collection-description-boa');
      if (!desc) return;
      const inner = desc.querySelector('.enlarge-text');
      if (!inner) return;
      const probe = inner.cloneNode(true);
      probe.style.cssText = 'position:absolute;visibility:hidden;display:block;height:auto;max-height:none;-webkit-line-clamp:unset;pointer-events:none;width:' + desc.clientWidth + 'px';
      document.body.appendChild(probe);
      const fullHeight = probe.scrollHeight;
      probe.remove();
      const toggle = document.getElementById('collection-show-description');
      if (fullHeight > 63) {
        desc.style.display = '-webkit-box';
      } else {
        desc.style.display = 'block';
        if (toggle) toggle.style.display = 'none';
      }
    }
    checkLenghtDesc();

    $('.explaination').on('click', function(e) {
      e.preventDefault();
      let heightExp = $(this).find('.explanation_content');
      heightExp.css('bottom', -heightExp.innerHeight() / 2 + 15 );
      $(this).toggleClass('active');
    })

    /**
    * change images in loop on hover
    */
    $('.grid-product__colors .color-swatch').on('mouseover', function() {
      let curImage = $(this).attr('data-variant-image');
      $(this).closest('.grid-product').find('.color_variant_img.grid-product__color-image').css('backgroundImage', `url(${curImage})`).addClass('is-active');
    })
    $('.grid-product__colors .color-swatch').on('mouseleave', function() {
      let curImage = $(this).attr('data-variant-image');
      $(this).closest('.grid-product').find('.color_variant_img.grid-product__color-image').css('backgroundImage', '').removeClass('is-active');
    })
    $('.grid-product__colors .color-swatch').on('click', function(e) {
      e.preventDefault();
      let newHref = $(this).attr('data-url');
      if (!newHref) {
        newHref = $(this).closest('.grid-product, .card-wrapper').find('.full-unstyled-link, .grid-item__link').first().attr('href');
      }
      if (newHref) {
        window.location.href = newHref;
      }
    });

    /**
     *
     * @param name , valuem , time
     * @returns string value
     */
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      // d.setTime(d.getTime() + (exdays*24*60*60*1000));
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = 'expires='+ d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    /**
     *
     * @param name
     * @returns string value
     */
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    $('#CustomerEmail').on('blur', function() {
      setCookie( 'сustomerEmail', $(this).val(), 30 );
    });

    if ( $('#CustomerEmail').length > 0 && getCookie('сustomerEmail') ) {
      $('#CustomerEmail').val(getCookie('сustomerEmail'));
    }
    
  })
})(window.jQuery)

var PriceRange = class extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    const rangeLowerBound = this.querySelector('input[type="range"]:first-child'), rangeHigherBound = this.querySelector('input[type="range"]:last-child'), textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'), textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: this.#abortController.signal });
    textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: this.#abortController.signal });
    textInputLowerBound?.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
      rangeLowerBound.value = event.target.value;
      rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max) * 100}%`);
    }, { signal: this.#abortController.signal });
    textInputHigherBound?.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
      rangeHigherBound.value = event.target.value;
      rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(rangeHigherBound.value) / parseInt(rangeHigherBound.max) * 100}%`);
    }, { signal: this.#abortController.signal });
    rangeLowerBound?.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeHigherBound?.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeLowerBound?.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputLowerBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
    rangeHigherBound?.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputHigherBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

/**
 * Homepage scroll restoration (back navigation).
 * Native restoration is disabled site-wide when scrollRestoration is "manual";
 * async Flickity/images can also shift layout after restore. Save on leave, re-apply after init.
 */
(function () {
  const ZR_HOMEPAGE_SCROLL_KEY = 'zr:homepage-scroll:v1';
  const MAX_RESTORE_ATTEMPTS = 14;

  const isHomepage = () =>
    document.body && document.body.classList.contains('template-index');

  const homepagePath = () => window.location.pathname || '/';

  const safeGet = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(ZR_HOMEPAGE_SCROLL_KEY) || 'null');
    } catch (e) {
      return null;
    }
  };

  const safeSet = (scrollY) => {
    try {
      window.sessionStorage.setItem(
        ZR_HOMEPAGE_SCROLL_KEY,
        JSON.stringify({ path: homepagePath(), scrollY, ts: Date.now() })
      );
    } catch (e) {}
  };

  const safeClear = () => {
    try {
      window.sessionStorage.removeItem(ZR_HOMEPAGE_SCROLL_KEY);
    } catch (e) {}
  };

  const isBackNavigation = () => {
    const nav =
      performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') return true;
    if (performance.navigation && performance.navigation.type === 2) return true;
    return false;
  };

  const setScrollRestorationAuto = () => {
    if ('scrollRestoration' in history && isHomepage()) {
      try {
        history.scrollRestoration = 'auto';
      } catch (e) {}
    }
  };

  let restorePending = false;
  let restoreAttempts = 0;

  const applyScroll = (targetY) => {
    const doc = document.documentElement;
    const maxY = Math.max(0, (doc ? doc.scrollHeight : 0) - window.innerHeight);
    const y = Math.min(Math.max(0, targetY), maxY);
    window.scrollTo(0, y);
    return Math.abs(window.scrollY - y) < 64;
  };

  const restoreHomepageScroll = () => {
    if (!isHomepage() || !restorePending) return;

    const data = safeGet();
    if (!data || data.path !== homepagePath() || typeof data.scrollY !== 'number') {
      restorePending = false;
      return;
    }

    const targetY = data.scrollY;
    const done = applyScroll(targetY);
    restoreAttempts += 1;

    if (done || restoreAttempts >= MAX_RESTORE_ATTEMPTS) {
      safeClear();
      restorePending = false;
      restoreAttempts = 0;
      return;
    }

    const delay = restoreAttempts < 4 ? 50 : 150;
    window.requestAnimationFrame(() => {
      window.setTimeout(restoreHomepageScroll, delay);
    });
  };

  const beginRestore = () => {
    if (!isHomepage() || !safeGet()) return;
    restorePending = true;
    restoreAttempts = 0;
    restoreHomepageScroll();
  };

  const saveHomepageScroll = () => {
    if (!isHomepage()) return;
    safeSet(window.scrollY);
  };

  window.addEventListener('pagehide', saveHomepageScroll);

  window.addEventListener('pageshow', (evt) => {
    if (!isHomepage()) return;
    setScrollRestorationAuto();

    const isBack = evt.persisted || isBackNavigation();
    if (isBack) {
      beginRestore();
    } else {
      safeClear();
      restorePending = false;
    }
  });

  document.addEventListener('DOMContentLoaded', setScrollRestorationAuto);
  // Retry after theme.js inits Flickity sections (page:loaded).
  document.addEventListener('page:loaded', () => {
    if (isHomepage() && safeGet()) {
      beginRestore();
    }
  });
})();

window.addEventListener('DOMContentLoaded', () => {
  const originalContainer = document.querySelector('.template-article .page-content');
  if (!originalContainer) return;

  const newMainWrapper = document.createElement('div');
  newMainWrapper.classList.add('split__main');

  const newSidebarWrapper = document.createElement('div');
  newSidebarWrapper.classList.add('split__sidebar');

  Array.from(originalContainer.children).forEach(child => {
    // console.log(child)
    if (child.matches('.blog-layout__sidebar') || child.matches('.featured-collection-section-container')) {
      newSidebarWrapper.appendChild(child);
    } else {
      newMainWrapper.appendChild(child);
    }
  });

  // Clear original and append new structure
  originalContainer.innerHTML = '';
  originalContainer.appendChild(newMainWrapper);
  originalContainer.appendChild(newSidebarWrapper);
});